package info.rezident.app.data.common

import info.rezident.app.data.quiz.QuizQuestion
import info.rezident.app.data.quiz.QuizUserAnswers

/**
 * Resolves the academic year from quiz answers using the loaded questions.
 * Business rule: academic year is selected in question with ID 30, via predefined answers.
 */
object AcademicYearResolver {
    private const val ACADEMIC_YEAR_QUESTION_ID: Int = 30

    fun resolveAcademicYear(answers: QuizUserAnswers, questions: List<QuizQuestion>): String? {
        val answer = answers.answers.firstOrNull { it.questionId == ACADEMIC_YEAR_QUESTION_ID } ?: return null
        val matchId: Int = answer.answerIds?.firstOrNull() ?: return null
        val question = questions.firstOrNull { it.id == ACADEMIC_YEAR_QUESTION_ID } ?: return null
        return question.predefinedPredefinedAnswers.firstOrNull { it.id == matchId }?.text
    }
}
